import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { NgProgress, NgProgressRef } from 'ngx-progressbar';
import { Subscription } from 'rxjs';
import { ApiAttributesGroupsService } from 'src/app/services';
import { ApiAttributesService } from 'src/app/services/api-attributes.service';

@Component({
  selector: 'app-deleting-attribute-group',
  templateUrl: './deleting-attribute-group.component.html',
  styleUrls: ['./deleting-attribute-group.component.css']
})
export class DeletingAttributeGroupComponent implements OnInit {

  progressRef: NgProgressRef;
  subscriptions: Subscription = new Subscription();

  atributGroupId: any;
  attributeInfo: any;
  attrCount: number;

  @Input() set data(value) {

    if (value != null) {

      this.atributGroupId = value.id;
      this.attrInfo(value.id);
    }
  }

  constructor(
    public ngProgress: NgProgress, 
    public activeModal: NgbActiveModal,  
    private apiService: ApiAttributesGroupsService,
  ) { }

  ngOnInit(): void {

    this.progressRef = this.ngProgress.ref('progress-bar');
  }


  /**
   * 
   */
  attrInfo(id) {

    let data = {
      id: id,
      mandatory: false
    }

    // this.progressRef.start();

    this.subscriptions.add(
      this.apiService.delete(data).subscribe(response => { console.log('[RESPONSE] attrInfo: ', response);

        if (response != null) {

          for(let i of response.result) {

            this.attrCount = i.count
          }

          this.attributeInfo = response.result;
        }

        // this.progressRef.complete();
      })
    );
  }


  /**
   * 
   */
  delete() {

    let data = {
      id: this.atributGroupId,
      mandatory: true
    }

    this.progressRef.start();

    this.subscriptions.add(
      this.apiService.delete(data).subscribe(response => { console.log('[RESPONSE] attrInfo: ', response);

        if (response != null) {

          this.activeModal.close(true); //close
        }

        this.progressRef.complete();
      })
    );
  }


  // /**
  //  * 
  //  */
  // close(data) {
    
  //   this.activeModal.close(data);
  // }

}
